export const content = [
    {
        type: '$$question?$$',
        desp: "When framing a query enclosed with the special character '$', it retrieves the response from the text-to-SQL database.",
    },
    {
        type: '##question?##',
        desp: "When framing a query enclosed with the special character '#', it retrieves the response from the URL scraped database.",
    },
    {
        type: 'Question?',
        desp: 'When framing a query without special characters, it retrieves the response from the manual database.If the response is not found, it proceeds to check the scraped database.',
    },
];
